import React from 'react';
import { SIZE_AGES } from '../data/collection';
interface SizeTableProps {
  caption?: string;
  compact?: boolean;
}

/** Two-column table: height (size) and approximate age. */
export function SizeTable({
  caption = 'Talles por estatura y edad aproximada',
  compact = false
}: SizeTableProps) {
  const cell = compact ? 'px-4 py-2 text-[0.98rem]' : 'px-5 py-2.5 text-[1.02rem]';
  return <div className="w-full min-w-0 overflow-hidden rounded-[16px] bg-paper ring-1 ring-ivory-line" data-id="element-309" data-mp="6nl8ae3qb3h6">
      <table className="w-full border-collapse text-left" data-id="element-310" data-mp="bm4r45n0zz5b">
        <caption className="sr-only" data-id="element-311" data-mp="boh92issa9id">{caption}</caption>
        <thead data-id="element-312" data-mp="3t3o07tmz6flq">
          <tr className="bg-blush" data-id="element-313" data-mp="3t24li7gywcm2">
            <th scope="col" className={`${cell} font-extrabold text-coral-ink`} data-id="element-314" data-mp="3t11tfw7ws44k">
              Estatura
            </th>
            <th scope="col" className={`${cell} font-extrabold text-coral-ink`} data-id="element-315" data-mp="pmfjxe7wbnt4">
              Edad aproximada
            </th>
          </tr>
        </thead>
        <tbody data-id="element-316" data-mp="ue71x0czkl7n">
          {SIZE_AGES.map(row => <tr key={row.height} className="border-t border-ivory-line" data-id="element-317" data-mp="1lg65cl84o712">
              <th scope="row" className={`${cell} whitespace-nowrap font-bold text-graphite`} data-id="element-318" data-mp="1ghmmwusqtddg">
                {row.height}
              </th>
              <td className={`${cell} text-graphite-soft`} data-id="element-319" data-mp="1v7kbvcyhy73p">{row.age}</td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}